import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * The JSM Journeys List Route. Shows work items in a lis associated with running journeys.
 * Journeys List: /jira/servicedesk/projects/:projectKey/journeys/
 */
export const journeysListRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/journeys',
	name: 'jsm-journeys-list',
	exact: true,
};
